/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Swal_CancelInputs */

const en_paste_swal_cancel = /** @type {(inputs: Paste_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Original Timing`)
};

const fr_paste_swal_cancel = /** @type {(inputs: Paste_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser le Minutage d'Origine`)
};

const de_paste_swal_cancel = /** @type {(inputs: Paste_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originale Zündung verwenden`)
};

const it_paste_swal_cancel = /** @type {(inputs: Paste_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa la temporizzazione originale`)
};

const ru_paste_swal_cancel = /** @type {(inputs: Paste_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Использовать исходное время`)
};

const es_paste_swal_cancel = /** @type {(inputs: Paste_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilice la sincronización original`)
};

const zh_cn2_paste_swal_cancel = /** @type {(inputs: Paste_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用原时序`)
};

const ja_paste_swal_cancel = /** @type {(inputs: Paste_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリジナルのタイミングを使用する`)
};

const hi_paste_swal_cancel = /** @type {(inputs: Paste_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल समय का उपयोग करें`)
};

const pt_pt2_paste_swal_cancel = /** @type {(inputs: Paste_Swal_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a sincronização original`)
};

/**
* | output |
* | --- |
* | "Use Original Timing" |
*
* @param {Paste_Swal_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_swal_cancel = /** @type {((inputs?: Paste_Swal_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Swal_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_swal_cancel(inputs)
	if (locale === "de") return de_paste_swal_cancel(inputs)
	if (locale === "it") return it_paste_swal_cancel(inputs)
	if (locale === "ru") return ru_paste_swal_cancel(inputs)
	if (locale === "es") return es_paste_swal_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_swal_cancel(inputs)
	if (locale === "ja") return ja_paste_swal_cancel(inputs)
	if (locale === "hi") return hi_paste_swal_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_swal_cancel(inputs)
	return en_paste_swal_cancel(inputs)
});